const { assoc, pipe } = require("ramda");

/**
 * Helper module to send a 405 - Method not allowed HTTP response.
 */
module.exports = (ctx) => pipe(assoc("status", 405), ctx.error)({});
